<script>
import { bApp, COVER_TYPE } from 'base/config'
import { addClass } from 'common/js/dom'
import { getUrlParam } from 'common/js/common'
import { URL_PARAM, APP_CHANNEL } from 'common/utils/variables'

export default {
  name: 'Cover',
  directives: {
    loadimg(el) {
      const src = el.src
      const newImg = new Image()
      newImg.src = src
      newImg.onload = function() {
        addClass(el, 'img-load')
      }
    }
  },
  props: {
    plan: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      coverType: '',
      coverTypeImg: ''
    }
  },
  computed: {},
  created() {
    this.coverInit()
  },
  mounted() {
    if (bApp || getUrlParam('tData') || getUrlParam('replay') || URL_PARAM.cover === '0' || ['WECHAT_GAOKE', 'WECHAT_GAOKE_CUSTOMER'].includes(APP_CHANNEL)) {
      this.closeCover(true)
      return
    }
    this.$nextTick(() => {
      this.closeCover()
    })
  },
  methods: {
    coverInit() {
      const coverId = getUrlParam('coverId')
      const coverImg = getUrlParam('coverImg')
      this.coverType = coverId ? `cover_t${coverId}` : null
      this.coverTypeImg = coverImg ? coverImg : this.coverType ? COVER_TYPE[this.coverType] : ''
    },
    closeCover(value) {
      this.$emit('close', value)
    }
  }
}
</script>
<template>
  <div
    ref="cover"
    class="cover"
    :class="[coverType]"
    @click="closeCover(true)"
  >
    <div v-if="coverTypeImg" class="cover-type-inner">
      <div class="cover-type-bd">
        <img
          v-loadimg
          :src="coverTypeImg"
          class="cover-type-img"
          alt="保险让生活更美好"
        >
        <!-- {{ plan.name }} {{ plan.sex }} -->
        <p>敬呈</p>
      </div>
    </div>
    <dl v-else class="cover-inner">
      <dt class="cover-title">
        <img
          src="//img.winbaoxian.com/autoUpload/planbook/resultCoverTil_8db33f9ca805866.png"
          alt="保险让生活更美好"
        >
      </dt>
      <dd class="cover-bd">
        <div class="cover-btn-wrap">
          <div v-if="plan.avatar" class="cover-avatar">
            <img class="avatar-img" alt="name" :src="plan.avatar">
          </div>
          <i v-else class="cover-btn">亲启</i>
          <p v-if="plan.avatar">
            敬呈 “{{ plan.nickname }}” 亲启
          </p>
        </div>
      </dd>
    </dl>
  </div>
</template>
<style lang="less" scoped>
@import './cover.less';
</style>
